module.exports = __webpack_public_path__ + "static/media/c4.f28870b6.jpg";